export default "__VITE_ASSET__2a048ee8__"